import React, { useEffect, useRef, useState } from "react";
import { CheckCircle2, Clock, Loader2, XCircle, Smartphone } from "lucide-react";
import { api } from "../lib/api";

const COPY = {
  PAID: ["Pembayaran berhasil", "Kredit sudah masuk ke saldo Anda. Kembali ke aplikasi untuk melanjutkan."],
  PENDING: ["Menunggu konfirmasi pembayaran", "Biasanya hanya beberapa detik. Anda boleh kembali ke aplikasi — saldo bertambah otomatis begitu DOKU mengonfirmasi."],
  EXPIRED: ["Pembayaran kedaluwarsa", "Batas waktu pembayaran sudah lewat. Silakan buat pembayaran baru dari aplikasi."],
  FAILED: ["Pembayaran belum berhasil", "Anda bisa mencoba lagi dengan metode lain dari aplikasi."],
  ERROR: ["Pembayaran tidak ditemukan", "Tautan ini tidak valid atau sudah tidak berlaku."],
};

// Public bridge page for the native app: DOKU redirects here, we show status and hand off to oryntix://wallet.
export default function PayReturn() {
  const q = new URLSearchParams(window.location.search);
  const invoice = q.get("invoice");
  const token = q.get("t") || "";
  const [p, setP] = useState(null);
  const handedOff = useRef(false);

  useEffect(() => {
    let alive = true, timer, tries = 0;
    const openApp = (link) => { if (!handedOff.current && link) { handedOff.current = true; window.location.href = link; } };
    const tick = async () => {
      try {
        const r = await api.get(`/payments/doku/return/${encodeURIComponent(invoice || "")}`, { params: { t: token } });
        if (!alive) return;
        setP(r.data);
        if (r.data.status === "PENDING" && ++tries < 8) { timer = setTimeout(tick, 2500); return; }
        openApp(r.data.app_link);
      } catch { if (alive) setP({ status: "ERROR" }); }
    };
    tick();
    return () => { alive = false; clearTimeout(timer); };
  }, [invoice, token]);

  const st = p?.status;
  const [title, body] = COPY[st] || ["Memeriksa pembayaran…", "Mohon tunggu sebentar."];
  const ok = st === "PAID", bad = st === "EXPIRED" || st === "FAILED" || st === "ERROR";
  const Icon = !st ? Loader2 : ok ? CheckCircle2 : bad ? XCircle : Clock;
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0f1f] p-6" data-testid="pay-return-page">
      <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#111a33] p-7 text-white shadow-2xl fade-up">
        <p className="text-lg font-extrabold tracking-wide">Oryntix</p>
        <div className={`mt-6 flex h-14 w-14 items-center justify-center rounded-2xl ${ok ? "bg-emerald-500/15 text-emerald-400" : bad ? "bg-rose-500/15 text-rose-400" : "bg-amber-500/15 text-amber-300"}`}>
          <Icon size={28} className={!st ? "animate-spin" : ""} />
        </div>
        <h1 className="mt-4 text-2xl font-black" data-testid="pay-return-title">{title}</h1>
        <p className="mt-2 text-sm leading-relaxed text-white/70">{body}</p>
        {p?.amount ? (
          <div className="mt-5 space-y-1.5 rounded-2xl bg-white/5 p-4 text-sm" data-testid="pay-return-detail">
            <p className="flex justify-between"><span className="text-white/50">Invoice</span><span className="font-mono text-xs">{p.invoice_number}</span></p>
            <p className="flex justify-between"><span className="text-white/50">Paket</span><span>{p.package_name}</span></p>
            <p className="flex justify-between"><span className="text-white/50">Kredit</span><span>{Number(p.credits).toLocaleString("id-ID")}</span></p>
            <p className="flex justify-between"><span className="text-white/50">Total</span><span className="font-semibold">Rp {Number(p.amount).toLocaleString("id-ID")}</span></p>
          </div>
        ) : null}
        <a href={p?.app_link || `oryntix://wallet${invoice ? `?payment=${encodeURIComponent(invoice)}` : ""}`}
           className="btn-grad mt-6 flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold" data-testid="pay-return-open-app">
          <Smartphone size={16} /> Kembali ke aplikasi
        </a>
        <a href="/wallet" className="mt-3 block text-center text-xs text-white/50 hover:text-white/80" data-testid="pay-return-open-web">Buka Dompet di web</a>
      </div>
    </div>
  );
}
